import { dayjs } from '@/api/utils/dayjs'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const DailyIcon: FunctionalComponent = () => {
  const weekDay = dayjs().format('dd')
  const day = dayjs().format('D')

  return (
    <div class={styles.root}>
      <div class={styles.day}>
        {weekDay}
      </div>
      <div class={styles.date}>
        {day}
      </div>
    </div>
  )
}
